<template>
  <div class="idType">
    <div class="box">
      <div class="left">
      <div class="title">{{ displayName }}</div>
        <div class="content">
          <time>{{ orderDetails.itemList[0].playDate }}</time>
          <span>{{ orderDetails.itemList[0].playPeriodName }}</span>
        </div>
      </div>
      <img class="right" src="~@/assets/image/common/common_logo.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "idType",
  props:['orderDetails'],
  data() {
    return {
      displayName: '',
      windowList: []
    }
  },
  watch: {
    orderDetails: {
      handler(newValue){
        const ticketIds = [...new Set(newValue.itemList.reduce((totalList, currentValue) => {
          totalList.push(currentValue.ticketSn);
          return totalList;
        }, []))];
        const currentItem = this.$store.getters.fullPackageDisplayWindow.find(item => item.totalOffPeakSeasonProductSns.some(v => ticketIds.includes(v)));
        if(currentItem){
          this.displayName = currentItem.title;
        }else{
          this.displayName = newValue.itemList[0].displayName;
        };
      },
      immediate: true,
      deep: true,
    }
  }
};
</script>

<style scoped lang='less'>
.idType{
  padding: .32rem .32rem 0;
  .box{
    display: flex;
    justify-content: space-between;
    padding: 0 .133333rem .266667rem;
  }
  .left{
    .title{
      color: #222328;
      font-size: .48rem;
      line-height: .253333rem * 2;
      font-weight: bold;
    }
    .content{
      margin-top: .24rem;
      font-size: .426667rem;
      color: #A1A6BA;
      line-height: .533333rem;
      time{
        margin-right: .32rem;
      }
    }
  }
  .right{
    height: .626667rem * 2;
  }
}
</style>
